/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as OnboardingRouteImport } from './routes/onboarding/route'
import { Route as appRouteImport } from './routes/(app)/route'
import { Route as appIndexImport } from './routes/(app)/index'
import { Route as OnboardingSurveyImport } from './routes/onboarding/survey'
import { Route as OnboardingProvideWebsiteImport } from './routes/onboarding/provide-website'
import { Route as OnboardingCreateOrgImport } from './routes/onboarding/create-org'
import { Route as authSignUpImport } from './routes/(auth)/sign-up'
import { Route as authSignInImport } from './routes/(auth)/sign-in'
import { Route as appSnapshotImport } from './routes/(app)/snapshot'
import { Route as appSplatImport } from './routes/(app)/$'
import { Route as authStudioAuthRouteImport } from './routes/(auth)/studio-auth/route'
import { Route as appSettingsRouteImport } from './routes/(app)/settings/route'
import { Route as authStudioAuthIndexImport } from './routes/(auth)/studio-auth/index'
import { Route as appPagesIndexImport } from './routes/(app)/pages/index'
import { Route as appConversionsIndexImport } from './routes/(app)/conversions/index'
import { Route as appSettingsBillingImport } from './routes/(app)/settings/billing'
import { Route as appPagesPageIdRouteImport } from './routes/(app)/pages/$pageId/route'
import { Route as appSettingsGuidesIndexImport } from './routes/(app)/settings/guides/index'
import { Route as appPagesPageIdIndexImport } from './routes/(app)/pages/$pageId/index'
import { Route as appPagesPageIdVariantsRouteImport } from './routes/(app)/pages/$pageId/variants/route'
import { Route as appPagesPageIdVariantsIndexImport } from './routes/(app)/pages/$pageId/variants/index'
import { Route as appPagesPageIdVariantsVariantIdRouteImport } from './routes/(app)/pages/$pageId/variants/$variantId/route'
import { Route as appPagesPageIdVariantsVariantIdIndexImport } from './routes/(app)/pages/$pageId/variants/$variantId/index'
import { Route as appPagesPageIdVariantsVariantIdTargetingImport } from './routes/(app)/pages/$pageId/variants/$variantId/targeting'

// Create/Update Routes

const OnboardingRouteRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRoute,
} as any)

const appRouteRoute = appRouteImport.update({
  id: '/(app)',
  getParentRoute: () => rootRoute,
} as any)

const appIndexRoute = appIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appRouteRoute,
} as any)

const OnboardingSurveyRoute = OnboardingSurveyImport.update({
  id: '/survey',
  path: '/survey',
  getParentRoute: () => OnboardingRouteRoute,
} as any)

const OnboardingProvideWebsiteRoute = OnboardingProvideWebsiteImport.update({
  id: '/provide-website',
  path: '/provide-website',
  getParentRoute: () => OnboardingRouteRoute,
} as any)

const OnboardingCreateOrgRoute = OnboardingCreateOrgImport.update({
  id: '/create-org',
  path: '/create-org',
  getParentRoute: () => OnboardingRouteRoute,
} as any)

const authSignUpRoute = authSignUpImport.update({
  id: '/(auth)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRoute,
} as any)

const authSignInRoute = authSignInImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRoute,
} as any)

const appSnapshotRoute = appSnapshotImport.update({
  id: '/snapshot',
  path: '/snapshot',
  getParentRoute: () => appRouteRoute,
} as any)

const appSplatRoute = appSplatImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => appRouteRoute,
} as any)

const authStudioAuthRouteRoute = authStudioAuthRouteImport.update({
  id: '/(auth)/studio-auth',
  path: '/studio-auth',
  getParentRoute: () => rootRoute,
} as any)

const appSettingsRouteRoute = appSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => appRouteRoute,
} as any)

const authStudioAuthIndexRoute = authStudioAuthIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => authStudioAuthRouteRoute,
} as any)

const appPagesIndexRoute = appPagesIndexImport.update({
  id: '/pages/',
  path: '/pages/',
  getParentRoute: () => appRouteRoute,
} as any)

const appConversionsIndexRoute = appConversionsIndexImport.update({
  id: '/conversions/',
  path: '/conversions/',
  getParentRoute: () => appRouteRoute,
} as any)

const appSettingsBillingRoute = appSettingsBillingImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => appSettingsRouteRoute,
} as any)

const appPagesPageIdRouteRoute = appPagesPageIdRouteImport.update({
  id: '/pages/$pageId',
  path: '/pages/$pageId',
  getParentRoute: () => appRouteRoute,
} as any)

const appSettingsGuidesIndexRoute = appSettingsGuidesIndexImport.update({
  id: '/guides/',
  path: '/guides/',
  getParentRoute: () => appSettingsRouteRoute,
} as any)

const appPagesPageIdIndexRoute = appPagesPageIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appPagesPageIdRouteRoute,
} as any)

const appPagesPageIdVariantsRouteRoute =
  appPagesPageIdVariantsRouteImport.update({
    id: '/variants',
    path: '/variants',
    getParentRoute: () => appPagesPageIdRouteRoute,
  } as any)

const appPagesPageIdVariantsIndexRoute =
  appPagesPageIdVariantsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appPagesPageIdVariantsRouteRoute,
  } as any)

const appPagesPageIdVariantsVariantIdRouteRoute =
  appPagesPageIdVariantsVariantIdRouteImport.update({
    id: '/$variantId',
    path: '/$variantId',
    getParentRoute: () => appPagesPageIdVariantsRouteRoute,
  } as any)

const appPagesPageIdVariantsVariantIdIndexRoute =
  appPagesPageIdVariantsVariantIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appPagesPageIdVariantsVariantIdRouteRoute,
  } as any)

const appPagesPageIdVariantsVariantIdTargetingRoute =
  appPagesPageIdVariantsVariantIdTargetingImport.update({
    id: '/targeting',
    path: '/targeting',
    getParentRoute: () => appPagesPageIdVariantsVariantIdRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(app)': {
      id: '/(app)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appRouteImport
      parentRoute: typeof rootRoute
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRoute
    }
    '/(app)/settings': {
      id: '/(app)/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof appSettingsRouteImport
      parentRoute: typeof appRouteImport
    }
    '/(auth)/studio-auth': {
      id: '/(auth)/studio-auth'
      path: '/studio-auth'
      fullPath: '/studio-auth'
      preLoaderRoute: typeof authStudioAuthRouteImport
      parentRoute: typeof rootRoute
    }
    '/(app)/$': {
      id: '/(app)/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof appSplatImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/snapshot': {
      id: '/(app)/snapshot'
      path: '/snapshot'
      fullPath: '/snapshot'
      preLoaderRoute: typeof appSnapshotImport
      parentRoute: typeof appRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpImport
      parentRoute: typeof rootRoute
    }
    '/onboarding/create-org': {
      id: '/onboarding/create-org'
      path: '/create-org'
      fullPath: '/onboarding/create-org'
      preLoaderRoute: typeof OnboardingCreateOrgImport
      parentRoute: typeof OnboardingRouteImport
    }
    '/onboarding/provide-website': {
      id: '/onboarding/provide-website'
      path: '/provide-website'
      fullPath: '/onboarding/provide-website'
      preLoaderRoute: typeof OnboardingProvideWebsiteImport
      parentRoute: typeof OnboardingRouteImport
    }
    '/onboarding/survey': {
      id: '/onboarding/survey'
      path: '/survey'
      fullPath: '/onboarding/survey'
      preLoaderRoute: typeof OnboardingSurveyImport
      parentRoute: typeof OnboardingRouteImport
    }
    '/(app)/': {
      id: '/(app)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/pages/$pageId': {
      id: '/(app)/pages/$pageId'
      path: '/pages/$pageId'
      fullPath: '/pages/$pageId'
      preLoaderRoute: typeof appPagesPageIdRouteImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/settings/billing': {
      id: '/(app)/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof appSettingsBillingImport
      parentRoute: typeof appSettingsRouteImport
    }
    '/(app)/conversions/': {
      id: '/(app)/conversions/'
      path: '/conversions'
      fullPath: '/conversions'
      preLoaderRoute: typeof appConversionsIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/pages/': {
      id: '/(app)/pages/'
      path: '/pages'
      fullPath: '/pages'
      preLoaderRoute: typeof appPagesIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(auth)/studio-auth/': {
      id: '/(auth)/studio-auth/'
      path: '/'
      fullPath: '/studio-auth/'
      preLoaderRoute: typeof authStudioAuthIndexImport
      parentRoute: typeof authStudioAuthRouteImport
    }
    '/(app)/pages/$pageId/variants': {
      id: '/(app)/pages/$pageId/variants'
      path: '/variants'
      fullPath: '/pages/$pageId/variants'
      preLoaderRoute: typeof appPagesPageIdVariantsRouteImport
      parentRoute: typeof appPagesPageIdRouteImport
    }
    '/(app)/pages/$pageId/': {
      id: '/(app)/pages/$pageId/'
      path: '/'
      fullPath: '/pages/$pageId/'
      preLoaderRoute: typeof appPagesPageIdIndexImport
      parentRoute: typeof appPagesPageIdRouteImport
    }
    '/(app)/settings/guides/': {
      id: '/(app)/settings/guides/'
      path: '/guides'
      fullPath: '/settings/guides'
      preLoaderRoute: typeof appSettingsGuidesIndexImport
      parentRoute: typeof appSettingsRouteImport
    }
    '/(app)/pages/$pageId/variants/$variantId': {
      id: '/(app)/pages/$pageId/variants/$variantId'
      path: '/$variantId'
      fullPath: '/pages/$pageId/variants/$variantId'
      preLoaderRoute: typeof appPagesPageIdVariantsVariantIdRouteImport
      parentRoute: typeof appPagesPageIdVariantsRouteImport
    }
    '/(app)/pages/$pageId/variants/': {
      id: '/(app)/pages/$pageId/variants/'
      path: '/'
      fullPath: '/pages/$pageId/variants/'
      preLoaderRoute: typeof appPagesPageIdVariantsIndexImport
      parentRoute: typeof appPagesPageIdVariantsRouteImport
    }
    '/(app)/pages/$pageId/variants/$variantId/targeting': {
      id: '/(app)/pages/$pageId/variants/$variantId/targeting'
      path: '/targeting'
      fullPath: '/pages/$pageId/variants/$variantId/targeting'
      preLoaderRoute: typeof appPagesPageIdVariantsVariantIdTargetingImport
      parentRoute: typeof appPagesPageIdVariantsVariantIdRouteImport
    }
    '/(app)/pages/$pageId/variants/$variantId/': {
      id: '/(app)/pages/$pageId/variants/$variantId/'
      path: '/'
      fullPath: '/pages/$pageId/variants/$variantId/'
      preLoaderRoute: typeof appPagesPageIdVariantsVariantIdIndexImport
      parentRoute: typeof appPagesPageIdVariantsVariantIdRouteImport
    }
  }
}

// Create and export the route tree

interface appSettingsRouteRouteChildren {
  appSettingsBillingRoute: typeof appSettingsBillingRoute
  appSettingsGuidesIndexRoute: typeof appSettingsGuidesIndexRoute
}

const appSettingsRouteRouteChildren: appSettingsRouteRouteChildren = {
  appSettingsBillingRoute: appSettingsBillingRoute,
  appSettingsGuidesIndexRoute: appSettingsGuidesIndexRoute,
}

const appSettingsRouteRouteWithChildren =
  appSettingsRouteRoute._addFileChildren(appSettingsRouteRouteChildren)

interface appPagesPageIdVariantsVariantIdRouteRouteChildren {
  appPagesPageIdVariantsVariantIdTargetingRoute: typeof appPagesPageIdVariantsVariantIdTargetingRoute
  appPagesPageIdVariantsVariantIdIndexRoute: typeof appPagesPageIdVariantsVariantIdIndexRoute
}

const appPagesPageIdVariantsVariantIdRouteRouteChildren: appPagesPageIdVariantsVariantIdRouteRouteChildren =
  {
    appPagesPageIdVariantsVariantIdTargetingRoute:
      appPagesPageIdVariantsVariantIdTargetingRoute,
    appPagesPageIdVariantsVariantIdIndexRoute:
      appPagesPageIdVariantsVariantIdIndexRoute,
  }

const appPagesPageIdVariantsVariantIdRouteRouteWithChildren =
  appPagesPageIdVariantsVariantIdRouteRoute._addFileChildren(
    appPagesPageIdVariantsVariantIdRouteRouteChildren,
  )

interface appPagesPageIdVariantsRouteRouteChildren {
  appPagesPageIdVariantsVariantIdRouteRoute: typeof appPagesPageIdVariantsVariantIdRouteRouteWithChildren
  appPagesPageIdVariantsIndexRoute: typeof appPagesPageIdVariantsIndexRoute
}

const appPagesPageIdVariantsRouteRouteChildren: appPagesPageIdVariantsRouteRouteChildren =
  {
    appPagesPageIdVariantsVariantIdRouteRoute:
      appPagesPageIdVariantsVariantIdRouteRouteWithChildren,
    appPagesPageIdVariantsIndexRoute: appPagesPageIdVariantsIndexRoute,
  }

const appPagesPageIdVariantsRouteRouteWithChildren =
  appPagesPageIdVariantsRouteRoute._addFileChildren(
    appPagesPageIdVariantsRouteRouteChildren,
  )

interface appPagesPageIdRouteRouteChildren {
  appPagesPageIdVariantsRouteRoute: typeof appPagesPageIdVariantsRouteRouteWithChildren
  appPagesPageIdIndexRoute: typeof appPagesPageIdIndexRoute
}

const appPagesPageIdRouteRouteChildren: appPagesPageIdRouteRouteChildren = {
  appPagesPageIdVariantsRouteRoute:
    appPagesPageIdVariantsRouteRouteWithChildren,
  appPagesPageIdIndexRoute: appPagesPageIdIndexRoute,
}

const appPagesPageIdRouteRouteWithChildren =
  appPagesPageIdRouteRoute._addFileChildren(appPagesPageIdRouteRouteChildren)

interface appRouteRouteChildren {
  appSettingsRouteRoute: typeof appSettingsRouteRouteWithChildren
  appSplatRoute: typeof appSplatRoute
  appSnapshotRoute: typeof appSnapshotRoute
  appIndexRoute: typeof appIndexRoute
  appPagesPageIdRouteRoute: typeof appPagesPageIdRouteRouteWithChildren
  appConversionsIndexRoute: typeof appConversionsIndexRoute
  appPagesIndexRoute: typeof appPagesIndexRoute
}

const appRouteRouteChildren: appRouteRouteChildren = {
  appSettingsRouteRoute: appSettingsRouteRouteWithChildren,
  appSplatRoute: appSplatRoute,
  appSnapshotRoute: appSnapshotRoute,
  appIndexRoute: appIndexRoute,
  appPagesPageIdRouteRoute: appPagesPageIdRouteRouteWithChildren,
  appConversionsIndexRoute: appConversionsIndexRoute,
  appPagesIndexRoute: appPagesIndexRoute,
}

const appRouteRouteWithChildren = appRouteRoute._addFileChildren(
  appRouteRouteChildren,
)

interface OnboardingRouteRouteChildren {
  OnboardingCreateOrgRoute: typeof OnboardingCreateOrgRoute
  OnboardingProvideWebsiteRoute: typeof OnboardingProvideWebsiteRoute
  OnboardingSurveyRoute: typeof OnboardingSurveyRoute
}

const OnboardingRouteRouteChildren: OnboardingRouteRouteChildren = {
  OnboardingCreateOrgRoute: OnboardingCreateOrgRoute,
  OnboardingProvideWebsiteRoute: OnboardingProvideWebsiteRoute,
  OnboardingSurveyRoute: OnboardingSurveyRoute,
}

const OnboardingRouteRouteWithChildren = OnboardingRouteRoute._addFileChildren(
  OnboardingRouteRouteChildren,
)

interface authStudioAuthRouteRouteChildren {
  authStudioAuthIndexRoute: typeof authStudioAuthIndexRoute
}

const authStudioAuthRouteRouteChildren: authStudioAuthRouteRouteChildren = {
  authStudioAuthIndexRoute: authStudioAuthIndexRoute,
}

const authStudioAuthRouteRouteWithChildren =
  authStudioAuthRouteRoute._addFileChildren(authStudioAuthRouteRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof appIndexRoute
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/settings': typeof appSettingsRouteRouteWithChildren
  '/studio-auth': typeof authStudioAuthRouteRouteWithChildren
  '/$': typeof appSplatRoute
  '/snapshot': typeof appSnapshotRoute
  '/sign-in': typeof authSignInRoute
  '/sign-up': typeof authSignUpRoute
  '/onboarding/create-org': typeof OnboardingCreateOrgRoute
  '/onboarding/provide-website': typeof OnboardingProvideWebsiteRoute
  '/onboarding/survey': typeof OnboardingSurveyRoute
  '/pages/$pageId': typeof appPagesPageIdRouteRouteWithChildren
  '/settings/billing': typeof appSettingsBillingRoute
  '/conversions': typeof appConversionsIndexRoute
  '/pages': typeof appPagesIndexRoute
  '/studio-auth/': typeof authStudioAuthIndexRoute
  '/pages/$pageId/variants': typeof appPagesPageIdVariantsRouteRouteWithChildren
  '/pages/$pageId/': typeof appPagesPageIdIndexRoute
  '/settings/guides': typeof appSettingsGuidesIndexRoute
  '/pages/$pageId/variants/$variantId': typeof appPagesPageIdVariantsVariantIdRouteRouteWithChildren
  '/pages/$pageId/variants/': typeof appPagesPageIdVariantsIndexRoute
  '/pages/$pageId/variants/$variantId/targeting': typeof appPagesPageIdVariantsVariantIdTargetingRoute
  '/pages/$pageId/variants/$variantId/': typeof appPagesPageIdVariantsVariantIdIndexRoute
}

export interface FileRoutesByTo {
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/settings': typeof appSettingsRouteRouteWithChildren
  '/$': typeof appSplatRoute
  '/snapshot': typeof appSnapshotRoute
  '/sign-in': typeof authSignInRoute
  '/sign-up': typeof authSignUpRoute
  '/onboarding/create-org': typeof OnboardingCreateOrgRoute
  '/onboarding/provide-website': typeof OnboardingProvideWebsiteRoute
  '/onboarding/survey': typeof OnboardingSurveyRoute
  '/': typeof appIndexRoute
  '/settings/billing': typeof appSettingsBillingRoute
  '/conversions': typeof appConversionsIndexRoute
  '/pages': typeof appPagesIndexRoute
  '/studio-auth': typeof authStudioAuthIndexRoute
  '/pages/$pageId': typeof appPagesPageIdIndexRoute
  '/settings/guides': typeof appSettingsGuidesIndexRoute
  '/pages/$pageId/variants': typeof appPagesPageIdVariantsIndexRoute
  '/pages/$pageId/variants/$variantId/targeting': typeof appPagesPageIdVariantsVariantIdTargetingRoute
  '/pages/$pageId/variants/$variantId': typeof appPagesPageIdVariantsVariantIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/(app)': typeof appRouteRouteWithChildren
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/(app)/settings': typeof appSettingsRouteRouteWithChildren
  '/(auth)/studio-auth': typeof authStudioAuthRouteRouteWithChildren
  '/(app)/$': typeof appSplatRoute
  '/(app)/snapshot': typeof appSnapshotRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-up': typeof authSignUpRoute
  '/onboarding/create-org': typeof OnboardingCreateOrgRoute
  '/onboarding/provide-website': typeof OnboardingProvideWebsiteRoute
  '/onboarding/survey': typeof OnboardingSurveyRoute
  '/(app)/': typeof appIndexRoute
  '/(app)/pages/$pageId': typeof appPagesPageIdRouteRouteWithChildren
  '/(app)/settings/billing': typeof appSettingsBillingRoute
  '/(app)/conversions/': typeof appConversionsIndexRoute
  '/(app)/pages/': typeof appPagesIndexRoute
  '/(auth)/studio-auth/': typeof authStudioAuthIndexRoute
  '/(app)/pages/$pageId/variants': typeof appPagesPageIdVariantsRouteRouteWithChildren
  '/(app)/pages/$pageId/': typeof appPagesPageIdIndexRoute
  '/(app)/settings/guides/': typeof appSettingsGuidesIndexRoute
  '/(app)/pages/$pageId/variants/$variantId': typeof appPagesPageIdVariantsVariantIdRouteRouteWithChildren
  '/(app)/pages/$pageId/variants/': typeof appPagesPageIdVariantsIndexRoute
  '/(app)/pages/$pageId/variants/$variantId/targeting': typeof appPagesPageIdVariantsVariantIdTargetingRoute
  '/(app)/pages/$pageId/variants/$variantId/': typeof appPagesPageIdVariantsVariantIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/onboarding'
    | '/settings'
    | '/studio-auth'
    | '/$'
    | '/snapshot'
    | '/sign-in'
    | '/sign-up'
    | '/onboarding/create-org'
    | '/onboarding/provide-website'
    | '/onboarding/survey'
    | '/pages/$pageId'
    | '/settings/billing'
    | '/conversions'
    | '/pages'
    | '/studio-auth/'
    | '/pages/$pageId/variants'
    | '/pages/$pageId/'
    | '/settings/guides'
    | '/pages/$pageId/variants/$variantId'
    | '/pages/$pageId/variants/'
    | '/pages/$pageId/variants/$variantId/targeting'
    | '/pages/$pageId/variants/$variantId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/onboarding'
    | '/settings'
    | '/$'
    | '/snapshot'
    | '/sign-in'
    | '/sign-up'
    | '/onboarding/create-org'
    | '/onboarding/provide-website'
    | '/onboarding/survey'
    | '/'
    | '/settings/billing'
    | '/conversions'
    | '/pages'
    | '/studio-auth'
    | '/pages/$pageId'
    | '/settings/guides'
    | '/pages/$pageId/variants'
    | '/pages/$pageId/variants/$variantId/targeting'
    | '/pages/$pageId/variants/$variantId'
  id:
    | '__root__'
    | '/(app)'
    | '/onboarding'
    | '/(app)/settings'
    | '/(auth)/studio-auth'
    | '/(app)/$'
    | '/(app)/snapshot'
    | '/(auth)/sign-in'
    | '/(auth)/sign-up'
    | '/onboarding/create-org'
    | '/onboarding/provide-website'
    | '/onboarding/survey'
    | '/(app)/'
    | '/(app)/pages/$pageId'
    | '/(app)/settings/billing'
    | '/(app)/conversions/'
    | '/(app)/pages/'
    | '/(auth)/studio-auth/'
    | '/(app)/pages/$pageId/variants'
    | '/(app)/pages/$pageId/'
    | '/(app)/settings/guides/'
    | '/(app)/pages/$pageId/variants/$variantId'
    | '/(app)/pages/$pageId/variants/'
    | '/(app)/pages/$pageId/variants/$variantId/targeting'
    | '/(app)/pages/$pageId/variants/$variantId/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  appRouteRoute: typeof appRouteRouteWithChildren
  OnboardingRouteRoute: typeof OnboardingRouteRouteWithChildren
  authStudioAuthRouteRoute: typeof authStudioAuthRouteRouteWithChildren
  authSignInRoute: typeof authSignInRoute
  authSignUpRoute: typeof authSignUpRoute
}

const rootRouteChildren: RootRouteChildren = {
  appRouteRoute: appRouteRouteWithChildren,
  OnboardingRouteRoute: OnboardingRouteRouteWithChildren,
  authStudioAuthRouteRoute: authStudioAuthRouteRouteWithChildren,
  authSignInRoute: authSignInRoute,
  authSignUpRoute: authSignUpRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/(app)",
        "/onboarding",
        "/(auth)/studio-auth",
        "/(auth)/sign-in",
        "/(auth)/sign-up"
      ]
    },
    "/(app)": {
      "filePath": "(app)/route.tsx",
      "children": [
        "/(app)/settings",
        "/(app)/$",
        "/(app)/snapshot",
        "/(app)/",
        "/(app)/pages/$pageId",
        "/(app)/conversions/",
        "/(app)/pages/"
      ]
    },
    "/onboarding": {
      "filePath": "onboarding/route.tsx",
      "children": [
        "/onboarding/create-org",
        "/onboarding/provide-website",
        "/onboarding/survey"
      ]
    },
    "/(app)/settings": {
      "filePath": "(app)/settings/route.tsx",
      "parent": "/(app)",
      "children": [
        "/(app)/settings/billing",
        "/(app)/settings/guides/"
      ]
    },
    "/(auth)/studio-auth": {
      "filePath": "(auth)/studio-auth/route.tsx",
      "children": [
        "/(auth)/studio-auth/"
      ]
    },
    "/(app)/$": {
      "filePath": "(app)/$.tsx",
      "parent": "/(app)"
    },
    "/(app)/snapshot": {
      "filePath": "(app)/snapshot.tsx",
      "parent": "/(app)"
    },
    "/(auth)/sign-in": {
      "filePath": "(auth)/sign-in.tsx"
    },
    "/(auth)/sign-up": {
      "filePath": "(auth)/sign-up.tsx"
    },
    "/onboarding/create-org": {
      "filePath": "onboarding/create-org.tsx",
      "parent": "/onboarding"
    },
    "/onboarding/provide-website": {
      "filePath": "onboarding/provide-website.tsx",
      "parent": "/onboarding"
    },
    "/onboarding/survey": {
      "filePath": "onboarding/survey.tsx",
      "parent": "/onboarding"
    },
    "/(app)/": {
      "filePath": "(app)/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/pages/$pageId": {
      "filePath": "(app)/pages/$pageId/route.tsx",
      "parent": "/(app)",
      "children": [
        "/(app)/pages/$pageId/variants",
        "/(app)/pages/$pageId/"
      ]
    },
    "/(app)/settings/billing": {
      "filePath": "(app)/settings/billing.tsx",
      "parent": "/(app)/settings"
    },
    "/(app)/conversions/": {
      "filePath": "(app)/conversions/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/pages/": {
      "filePath": "(app)/pages/index.tsx",
      "parent": "/(app)"
    },
    "/(auth)/studio-auth/": {
      "filePath": "(auth)/studio-auth/index.tsx",
      "parent": "/(auth)/studio-auth"
    },
    "/(app)/pages/$pageId/variants": {
      "filePath": "(app)/pages/$pageId/variants/route.tsx",
      "parent": "/(app)/pages/$pageId",
      "children": [
        "/(app)/pages/$pageId/variants/$variantId",
        "/(app)/pages/$pageId/variants/"
      ]
    },
    "/(app)/pages/$pageId/": {
      "filePath": "(app)/pages/$pageId/index.tsx",
      "parent": "/(app)/pages/$pageId"
    },
    "/(app)/settings/guides/": {
      "filePath": "(app)/settings/guides/index.tsx",
      "parent": "/(app)/settings"
    },
    "/(app)/pages/$pageId/variants/$variantId": {
      "filePath": "(app)/pages/$pageId/variants/$variantId/route.tsx",
      "parent": "/(app)/pages/$pageId/variants",
      "children": [
        "/(app)/pages/$pageId/variants/$variantId/targeting",
        "/(app)/pages/$pageId/variants/$variantId/"
      ]
    },
    "/(app)/pages/$pageId/variants/": {
      "filePath": "(app)/pages/$pageId/variants/index.tsx",
      "parent": "/(app)/pages/$pageId/variants"
    },
    "/(app)/pages/$pageId/variants/$variantId/targeting": {
      "filePath": "(app)/pages/$pageId/variants/$variantId/targeting.tsx",
      "parent": "/(app)/pages/$pageId/variants/$variantId"
    },
    "/(app)/pages/$pageId/variants/$variantId/": {
      "filePath": "(app)/pages/$pageId/variants/$variantId/index.tsx",
      "parent": "/(app)/pages/$pageId/variants/$variantId"
    }
  }
}
ROUTE_MANIFEST_END */
